Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.commentsContentType = "application/json";
exports.sendNewMessageContentType = "multipart/form-data"
exports.newMessageContentType = "application/json";
exports.commentsApiMethodType = "GET";
exports.commentPOSTAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "Comments";
exports.labelBodyText = "Comments Body";
exports.hintCountryCode = "Select Country";
exports.errorCountryCodeNotSelected = "Please select country code";
exports.commentEndPoint = "/comments/comments"
exports.likeCommentEndPoint = "/comments/like_comment"
exports.userTextsEndpoint = "account_block/sms_contacts"
exports.userTextsNewAPIEndpoint = "bx_block_chat/conversations/add_customer"
exports.initChatEndpoint = "account_block/messages/chat_interaction"
exports.getFoldersEndPoint = "account_block/chat_folders"
exports.createFoldersEndpoint = "account_block/chat_folders"
exports.contactsSearchEndPoint = "/account_block/contacts/search?query="
exports.directPostEndPoint = "bx_block_posts/direct_post_contacts"
exports.singleDirectPostEndPoint = "bx_block_posts/direct_post_contacts/"
exports.sendMessageEndPoint = "account_block/messages"
exports.sendMessageNewAPIEndPoint = "/bx_block_chat/conversations"
exports.getChatMessageEndPoint = "/account_block/messages/get_chat_message"
exports.getChatMessageNewAPIEndPoint = "/bx_block_chat/conversations"
exports.createConversationNewAPIEndPoint = "/bx_block_chat/conversations"
exports.sendChatMessageEndPoint = "/account_block/messages/send_chat_message"
exports.createConversationEndPoint = "account_block/sms_contacts"
exports.userChatsEndPoint = "account_block/contacts/get_chat_contacts"
exports.userChatsConversationsEndPoint = "/bx_block_chat/conversations"
exports.searchCustomersEndPoint = "bx_block_chat/conversations/search_customers",
  exports.delteFolderEndPoint = "account_block/chat_folders/"
exports.teamMatesEndPoint = "bx_block_teammates/teammates"
exports.updateFolderEndPoint = "account_block/chat_folders/"
exports.dashboardGetUrl = "/bx_block_dashboard/dashboards";
exports.assignConversationEndPoint = "/account_block/sms_contacts/assign_conversation"
exports.searchUsersEndPoint = "bx_block_chat/conversations/search_users";
// Customizable Area End
